"use strict";

var React = require('react');

function ModalActions(props) {
  return React.createElement(
    "div",
    { className: "cf-modal__actions" },
    props.children
  );
}

module.exports = ModalActions;